import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import "../PartnerManagement/AddPartner/Style.css";
import { Col, Row } from "react-bootstrap";
import TextInput from "../Common/UITextInput/TextInput";
import { Form, Drawer, message, notification, Switch, Input } from "antd";
import UiDropDown from "../Common/UiDropDown/UiDropDown";
import {
  getAddEmployeeDetail,
  getEmployeeDetails,
  saveAddEmployeeDetails,
} from "../../redux/AddEmployee/action";
import { connect } from "react-redux";
import { getMasterBranchDataDetails } from "../../redux/BranchPrefernces/action";
import UiButton from "../Common/UiButton/UiButton";
import useForm from "../../common/hooks/useForm";
import useSession from "../CustomLogout/useSession";
import { saveAddUserDetails } from "../../redux/AddUserDetails/action";
import { useDispatch } from "react-redux";
const PartnerViewEditUserDetails = ({
  setPartnerRefresh,
  partnerRefresh,
  drawerOpen,
  setDrawerOpen,
  ...props
}) => {
  const tab = useSelector((state) => state?.accessManagement?.tab);
  const userTab = useSelector((state) => state?.userListingReducer?.tab);

  const handleSessionExpired = useSession();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const FormItem = Form.Item;
  const { state, onChangeTextHandler, setState } = useForm();
  const [data, setData] = useState({});
  const [btnDisable, setBtnDisable] = useState(false);
  const [trackActiveStatus, setTrackActiveStatus] = useState(true);
  const [skipCall, setSkipCall] = useState("");
  const [mobile, setMobile] = useState("");

  const handleActiveStatus = (checked) => {
    setTrackActiveStatus(checked);
    setSkipCall(checked === false ? "nocall" : "call");
  };

  const onClose = () => {
    setDrawerOpen(false);
    form.resetFields();
    setBtnDisable(false);
  };

  const emailAddress = data?.emailAddress;
  const activeStatus = data?.active ? "ACTIVE" : "IN-ACTIVE";

  const handleChange = (e) => {
    const digitsOnly = e.target.value.replace(/\D/g, "").slice(0, 10);
    setMobile(digitsOnly);
  };

  const validateIndianMobile = (_, value) => {
    const regex = /^[6-9]\d{9}$/;
    if (!value || regex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("Enter a valid mobile number"));
  };

  const handleKeyPress = (e) => {
    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const fetchData = async () => {
    try {
      const id = props.row?.original?.userId;
      if (!id) return;

      if (tab || userTab === "DEACTIVATED") return;

      if (skipCall === "nocall") return;

      const response = await props.getEmployeeDetails({
        accessToken: props.access_token,
        userId: id,
      });

      if (response.status === 200) {
        setData(response.data?.dto);
        setTrackActiveStatus(response.data?.dto?.active);

        form.setFieldsValue({
          userFirstName: response.data?.dto?.userFirstName,
          userLastName: response.data?.dto?.userLastName,
          emailAddress: response?.data?.dto?.emailAddress,
          mobileNo: response?.data?.dto?.mobileNo,
        });
      } else {
        if (response?.data?.error || response?.message) {
          const errorCode =
            response?.data?.error?.errorCode || response?.errorCode;
          const errorMessage =
            response?.data?.error?.message || response?.message;
          if (errorCode === "403" && response?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      }
    } catch (error) {
      console.log("line116", error);
    } finally {
      setSkipCall("call");
    }
  };

  useEffect(() => {
    fetchData();
  }, [
    props.row?.original?.userId,
    props?.access_token,
    props?.getEmployeeDetails,
    drawerOpen,
  ]);

  const handleEditUser = (data) => {
    const userData = {
      userFirstName: data?.userFirstName,
      userLastName: data?.userLastName,
      emailAddress: data?.emailAddress,
      mobileNo: data?.mobileNo,
      status: trackActiveStatus,
      userId: props.row?.original?.userId,
    };

    setBtnDisable(true);

    dispatch(
      saveAddUserDetails({
        values: userData,
        access_token: props?.access_token,
      })
    ).then((res) => {
      if (res && res?.status === 200) {
        setTimeout(() => {
          message.success("User Updated Successfully");
        }, 1000);
        setBtnDisable(false);
        form.resetFields();
        setDrawerOpen(false);
        setPartnerRefresh(true);
      }
      if (res?.data?.error || res.message) {
        const errorCode = res?.data?.error?.errorCode || res.errorCode;
        const errorMessage = res?.data?.error?.message || res.message;
        setBtnDisable(false);
        if (errorCode === "403" && res?.data?.error?.logoutStatus) {
          handleSessionExpired();
        } else {
          notification.error({
            message: errorMessage,
            duration: 5,
            placement: "top",
          });
        }
      }
    });
  };

  const handleMobileNumberKeyPress = (event) => {
    const { key, target } = event;
    const isValueExceedingLimit = target.value.length >= 10;

    if ((!/^\d$/.test(key) && key !== ".") || isValueExceedingLimit) {
      event.preventDefault();
    }
  };

  return (
    <div className="addpartner-section" id="add-employee-sec">
      <Drawer
        title="Basic Drawer"
        placement="right"
        onClose={onClose}
        open={drawerOpen}
        className="add-partner-dow"
      >
        <Form
          autoComplete="off"
          form={form}
          name="addEmployee"
          initialValues={{ activeStatus: true }}
          onFinish={handleEditUser}
        >
          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              className="add-content-partner"
            >
              <Col md={6} className="addpartnerheading">
                <h2 className="main-heading">Edit User</h2>
                <div className="headre-line"></div>
              </Col>
              <Col md={6} className="btn-section">
                <h2 onClick={onClose} className="cancel-btn-add">
                  cancel
                </h2>
                {/* <UiButton type="submit" title="Create Employee" /> */}
              </Col>
            </Col>
          </Row>

          <h4>USER INFO</h4>
          <Row className="form-group">
            <Col md={7} className="signatory-label-group">
              <p className="label">FIRST NAME</p>
              <p className="value name-sec break-words">
                {data.userFirstName ? data.userFirstName : "------"}
              </p>
            </Col>
            <Col md={4} className="signatory-label-group">
              <p className="label">LAST NAME</p>
              <p className="value break-words">
                {data.userLastName ? data.userLastName : "------"}
              </p>
            </Col>
          </Row>

          <Row className="form-group">
            <Col md={7} className="signatory-label-group">
              <p className="label">USER EMAIL</p>
              <p className="value name-sec break-words">
                {emailAddress ? emailAddress : "------"}
              </p>
            </Col>
            <Col md={4} className="signatory-label-group">
              <p className="label">MOBILE NO</p>
              <p className="value break-words">
                {data?.mobileNo ? data?.mobileNo : "------"}
              </p>
            </Col>
          </Row>
          <Row className="form-group">
            <Col md={7} className="signatory-label-group">
              <p className="label">Active Status</p>
              <p className="value name-sec break-words">{activeStatus}</p>
            </Col>
          </Row>

          <h3 className="sub-text">User Info</h3>
          <Row>
            <Col lg={12} xs={12} md={12} sm={12} className="add-fields-partner">
              <Col md={6} className="mob-sec-eF">
                <FormItem
                  name="userFirstName"
                  label="First Name"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter First Name",
                    },
                  ]}
                >
                  <TextInput
                    type="text"
                    maxLength={75}
                    onInput={(e) => {
                      let value = e.target.value;
                      // Remove leading spaces
                      value = value.trimStart();
                      // Allow only alphabets and spaces (no numbers or special characters)
                      value = value.replace(/[^a-zA-Z\s]/g, "");
                      // Ensure no multiple spaces
                      value = value.replace(/\s+/g, " ");

                      e.target.value = value;
                    }}
                    name="userFirstName"
                    value={state.employeeFirstName}
                    onChange={onChangeTextHandler}
                  />
                </FormItem>
              </Col>
              <Col md={6} className="mob-sec-eF">
                <FormItem
                  name="userLastName"
                  label="Last Name"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Last Name",
                    },
                  ]}
                >
                  <TextInput
                    type="text"
                    maxLength={75}
                    onInput={(e) => {
                      let value = e.target.value;
                      // Remove leading spaces
                      value = value.trimStart();
                      // Allow only alphabets and spaces (no numbers or special characters)
                      value = value.replace(/[^a-zA-Z\s]/g, "");
                      // Ensure no multiple spaces
                      value = value.replace(/\s+/g, " ");

                      e.target.value = value;
                    }}
                    value={state.employeeLastName}
                    onChange={onChangeTextHandler}
                  />
                </FormItem>
              </Col>
            </Col>
          </Row>

          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              style={{ marginTop: "10px" }}
              className="add-fields-partner"
            >
              <Col md={6}>
                <FormItem
                  name="emailAddress"
                  label="Email Address"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Email",
                    },
                    {
                      type: "email",
                      message: "Enter Valid Email",
                    },
                  ]}
                >
                  <TextInput
                    maxLength={255}
                    type="email"
                    name="emailAddress"
                    onInput={(e) => {
                      if (e.target.value.trim() == "") {
                        e.target.value = e.target.value.trim();
                      }

                      if (e.target.value.trim() !== "") {
                        e.target.value = e.target.value.trimStart();
                      }
                    }}
                    onChange={onChangeTextHandler}
                  />
                </FormItem>
              </Col>
              <Col md={6} className="q-fix">
                <FormItem
                  name="mobileNo"
                  label="Mobile"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Mobile Number",
                    },
                    { validator: validateIndianMobile },
                  ]}
                >
                  <Input
                    value={mobile}
                    onKeyPress={handleKeyPress}
                    onChange={handleChange}
                    maxLength={10}
                    inputMode="numeric"
                    pattern="\d*"
                  />
                </FormItem>
              </Col>
            </Col>
          </Row>

          <h3 className="sub-text">Active Status</h3>
          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              style={{ marginTop: "0px" }}
              className="add-fields-partner"
            >
              <Col
                md={5}
                className=""
                // style={{ marginBottom: "3px", backgroundColor: "red" }}
              >
                <FormItem
                  name="activeStatus"
                  className="swicth-box-margin"
                  valuePropName="checked"
                  // label="Active Status"
                  colon={false}
                >
                  <Switch
                    checked={trackActiveStatus}
                    onChange={handleActiveStatus}
                    checkedChildren="Active"
                    unCheckedChildren="In-Active"
                    className="custom-switch swicth-box-margin"
                  />
                </FormItem>
              </Col>
            </Col>
          </Row>
          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              style={{ marginTop: "10px" }}
              className="add-fields-partner last-btn-sec-changes"
            >
              <Col md={12}>
                <UiButton
                  disabled={btnDisable}
                  type="submit"
                  title="Edit User"
                  className="primary-btn"
                />
              </Col>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    state: state && state.auth,
    access_token: state && state.auth && state.auth.idToken,
    addEmployeeData: state.addEmployeeData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAddEmployeeDetail: (accessToken) =>
      dispatch(getAddEmployeeDetail(accessToken)),
    saveAddEmployeeDetails: (data) => dispatch(saveAddEmployeeDetails(data)),
    getMasterBranchDataDetails: (data) =>
      dispatch(getMasterBranchDataDetails(data)),
    getEmployeeDetails: (data) => dispatch(getEmployeeDetails(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PartnerViewEditUserDetails);
